import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="flex min-h-screen flex-col items-start justify-center px-6 pt-24 sm:px-10">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
        <h1 className="font-serif text-4xl font-light tracking-tight sm:text-6xl">No charge made.</h1>
        <p className="mt-6 max-w-md text-base font-light leading-relaxed text-ash">
          You left checkout before paying — your cart is exactly as you left it, whenever you're ready.
        </p>
        <div className="mt-12 flex flex-wrap gap-4">
          <Link
            to="/shop"
            data-testid="cancel-back-to-shop"
            className="rounded-full bg-charcoal px-8 py-4 text-xs uppercase tracking-[0.2em] text-bone transition-colors duration-300 hover:bg-moss"
          >
            Back to the shop
          </Link>
        </div>
      </motion.div>
    </main>
  );
}
